
import Vue from 'vue'
import OnboardHeader from '../OnboardHeader'
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'

import lbpCommon, { i18nHelper, I18nLib } from '@it-common/lbp_common'

Vue.use(AjaxPlugin)
Vue.use(I18nLib)
Vue.use(lbpCommon)

export default {
components: {
OnboardHeader
},
data () {
return {
workList: [],
id: '',
loading: true,
hasShowPopup: {
data: false
}
}
},
created () {
this.id = this.$route.query.id
},
mounted () {
i18nHelper.loadLanguagePack(4159)
},
methods: {
showStep () {

this.$router.push({ name: 'onboard.preview', query: { id: this.id } })
}
}
}



// WEBPACK FOOTER //
// ./src/components/onboard/success.vue